import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";
import { Table, Container, Row, Col, Form } from "react-bootstrap";
import { format2 } from "../utils/rounding";

const ObInvRaportStoc = () => {
  const [items, setItems] = useState([]);
  const [angajati, setAngajati] = useState([]);
  const [angajatId, setAngajatId] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchRapoarte = async () => {
    setLoading(true);
    try {
      const res = await api.get("/obinv/rapoarte/stoc_angajat/", {
        params: { angajat_id: angajatId || null },
      });
      setItems(res.data.items || []);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    api.get("/angajati/").then(res => setAngajati(res.data)).catch(console.error);
  }, []);

  useEffect(() => {
    fetchRapoarte();
  }, [angajatId]);

  // Aggregate totals
  const totalValue = items.reduce((acc, it) => acc + (it.valoare_totala || 0), 0);

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col md={8}>
          <h2>Fișa Obiectelor de Inventar per Angajat (Sold)</h2>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Select 
              value={angajatId} 
              onChange={(e) => setAngajatId(e.target.value)}
            >
              <option value="">-- Toți angajații --</option>
              {angajati.map(a => <option key={a.id} value={a.id}>{a.nume_prenume}</option>)}
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Table striped bordered hover size="sm">
        <thead className="table-dark">
          <tr>
            <th>Angajat</th>
            <th>Obiect Inventar (Produs)</th>
            <th className="text-end">Cantitate în folosință</th>
            <th className="text-end">Preț Unitar</th>
            <th className="text-end">Valoare Totală</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan="5" className="text-center">Se încarcă datele...</td></tr>
          ) : items.length === 0 ? (
            <tr><td colSpan="5" className="text-center">Nu există stoc la angajați.</td></tr>
          ) : (
            items.map((item, idx) => (
              <tr key={idx}>
                <td>{item.angajat_nume}</td>
                <td>{item.produs_nume}</td>
                <td className="text-end fw-bold">{item.sold}</td>
                <td className="text-end">{format2(item.pret_unitar)}</td>
                <td className="text-end">{format2(item.valoare_totala)}</td>
              </tr>
            ))
          )}
        </tbody>
        {!loading && items.length > 0 && (
          <tfoot>
            <tr className="table-secondary fw-bold">
              <td colSpan="4" className="text-end">Total General:</td>
              <td className="text-end">{format2(totalValue)}</td>
            </tr>
          </tfoot>
        )}
      </Table>
    </Container>
  );
};

export default ObInvRaportStoc;
